import React from 'react'
import { Box } from '../Core'
import styled from 'styled-components'
//import { device } from '../../utils'
//import { Link } from 'gatsby'
//import { Button } from '../../components/Core'
const Img = props => <img {...props} />

const ImgStyled = styled(Img)`
    height: 36px;
    margin-right: 15px;
`
const FlexBox = styled(Box)`
    display: flex;
    flex-justify: center;
    align-items: center;
`

const StyledLink = styled.a`
    margin-top: -10px;
    border-bottom: 2px dotted gray;
    padding-bottom: 5px;
    display: inline-block;

    &:hover {
        border-color: blue;
    }
`

const A = ({ children, ...props }) => (
    <StyledLink {...props}>
        <FlexBox>{children}</FlexBox>
    </StyledLink>
)

const WebsiteLink = ({ src, href, children, ...rest }) => (
    <A href={href} target="_blank" rel="noopener noreferrer">
        <ImgStyled src={src} alt="favicon" />
        <Box>{children}</Box>
    </A>
)

export default WebsiteLink
